import http from '@/common/utils/http-common';
import IStyleData from '@/types/Style.type';

class StyleService {
  getAll() {
    return http.get('/styles');
  }

  get(id: string) {
    return http.get(`/styles/${id}`);
  }

  create(data: IStyleData) {
    return http.post('/styles', data);
  }

  update(data: IStyleData, id: any) {
    return http.put(`/styles/${id}`, data);
  }

  delete(id: any) {
    return http.delete(`/styles/${id}`);
  }
}

export default new StyleService();
